var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPadlockUnlocked = function SvgPadlockUnlocked(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.87281,24l-12.02632,0c-1.10464,0 -2.00439,-1.009 -2.00439,-2.25l0,-10.5c0,-1.241 0.89975,-2.25 2.00439,-2.25l12.02632,0c1.10464,0 2.00439,1.009 2.00439,2.25l0,10.5c0,1.241 -0.89975,2.25 -2.00439,2.25zm-12.02632,-13.5c-0.36792,0 -0.66813,0.336 -0.66813,0.75l0,10.5c0,0.414 0.30021,0.75 0.66813,0.75l12.02632,0c0.36792,0 0.66813,-0.336 0.66813,-0.75l0,-10.5c0,-0.414 -0.30021,-0.75 -0.66813,-0.75l-12.02632,0z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.35526,10.5c-0.414,0 -0.75,-0.336 -0.75,-0.75l0,-3.75c0,-2.481 -2.019,-4.5 -4.5,-4.5s-4.5,2.019 -4.5,4.5l0,3.75c0,0.414 -0.336,0.75 -0.75,0.75s-0.75,-0.336 -0.75,-0.75l0,-3.75c0,-3.309 2.691,-6 6,-6s6,2.691 6,6l0,3.75c0,0.414 -0.336,0.75 -0.75,0.75z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.7193,17c-1.103,0 -2,-0.897 -2,-2s0.897,-2 2,-2s2,0.897 2,2s-0.897,2 -2,2zm0,-2.5c-0.275,0 -0.5,0.224 -0.5,0.5s0.225,0.5 0.5,0.5s0.5,-0.224 0.5,-0.5s-0.225,-0.5 -0.5,-0.5z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15.7193,20c-0.414,0 -0.75,-0.336 -0.75,-0.75l0,-2.75c0,-0.414 0.336,-0.75 0.75,-0.75s0.75,0.336 0.75,0.75l0,2.75c0,0.414 -0.336,0.75 -0.75,0.75z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPadlockUnlocked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/padlock-unlocked.75e5a880128abbe6315c53b5b3b68cdd.svg";